<template>
    <div class="class condiciones">                 
        
            <div class="row">
                <div class="tab-content col-11 mx-auto pt-2" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="condiciones-generales" role="tabpanel"
                        aria-labelledby="condiciones-generales-tab">
                        <p>Todos los viajes combinados del programa “Edad de Oro” quedan sometidos a la información precontractual facilitada 
                            por la agencia organizadora, así como a las siguientes condiciones que serán facilitadas por la agencia 
                            vendedora al viajero para su aceptación.</p>
                        <h5>CONDICIONES GENERALES</h5>
                        <p><strong>Agencia Organizadora: </strong> La organización técnica de este viaje ha sido realizada por
                            la agencia de Viajes Mayorista-Minorista VIAJES CEMO S.A., con domicilio en Avda. de las
                            Gaviotas, 12-14 en Roquetas de Mar (Almería) titulo CIAN 04027-3 teléfono 950 627 019</p>
                        <p><strong>Agencia vendedora:</strong> Es la agencia de viajes distinta del organizador con la que contrata el viajero</p>
                        <p>El destino o destinos del viaje, los distintos periodos y sus fechas, la fecha y lugar de
                            salida, la fecha y lugar de regreso, de/los alojamiento/s, el medio de transporte, el
                            itinerario, las comidas previstas y el precio total y desglose serán los que figuren en la Reserva facilitados al viajero.</p>

                        <p><strong>Participación mínima: </strong> En el caso de viajes con transporte en autocar
                            incluido, se requiere un número mínimo de 30 participantes. En caso de no alcanzarse el
                            mismo, el viaje podrá cancelarse notificándose al viajero con una antelación mínima de 20
                            días a la fecha de salida.</p>

                        <p><strong>Forma de pago:</strong> Online en el momento de finalizar la reserva, en un único
                            pago a través de nuestra pasarela de pago seguro del banco BBVA.</p>

                        <p><strong>Cesión del viaje:</strong> El viajero podrá ceder el contrato de viaje a una persona
                            que reúna todas las condiciones aplicables a este contrato. La cesión deberá ser comunicada
                            por el cedente al
                            organizador con una antelación de, al menos, 7 días naturales al inicio del viaje combinado.
                            El viajero cedente, junto con el cesionario, será responsable del pago del precio del viaje
                            combinado, así como de cualquier comisión, recargo u otros costes adicionales derivados de
                            la cesión. El organizador o minorista deberá informar al cedente sobre los costes efectivos
                            de
                            la cesión.</p>

                        <p><strong>Responsabilidad: </strong> El viajero ha sido informado y entiende que el organizador
                            y la agencia vendedora son solidariamente responsables de la correcta ejecución de todos los
                            servicios de viaje incluidos en el contrato, así como de prestar asistencia si el viajero se haya en dificultades.</p>

                        <p><strong>Garantía: </strong>Viajes Cemo ha suscrito una garantía de protección frente a la
                            insolvencia con la compañía AXA SEGUROS GENERALES S.A. con número de póliza 62707991
                            domiciliada en Calle Emilio Vargas 6, Edificio Axa, 28043 Madrid Teléfono 91 1119543, e-mail: aperturas.empresas@axa.es
                        </p>

                        <p><strong>Faltas de conformidad: </strong>Los servicios del viaje combinado se entenderán
                            prestados de conformidad salvo que el viajero manifieste lo contrario, en cuyo caso deberá
                            informar al organizador o,
                            en su caso a la agencia vendedora, sin demora indebida. Las indemnizaciones por daños y
                            perjuicios que deba pagar el organizador y en su caso la agencia vendedora se verá restringidas por
                            aquellos límites aplicables a los prestadores de servicios de viaje incluidos en el viaje
                            combinado. Tratándose de daños no corporales las indemnizaciones tendrán un límite del
                            triple del importe del precio total del viaje siempre que no medie dolo o negligencia en la
                            producción del daño y deberán ser siempre acreditados por el viajero. Las limitaciones
                            anteriores no serán de aplicación a los daños corporales. El viajero tendrá derecho a presentar reclamaciones
                            con arreglo a al Real Decreto Legislativo 1/2007, el Reglamento (UE) nº. 181/2011 del
                            Parlamento Europeo y del Consejo, de 16 de febrero de 2011, sobre los
                            derechos de los viajeros de autobús y autocar y por el que se modifica el Reglamento (CE)
                            nº. 2006/2004, en su caso el resto de los reglamentos comunitarios aplicables, así como los
                            convenios internacionales. El viajero está obligado a tomar las medidas que sean necesarias
                            y/o adecuadas para tratar de aminorar los daños que puedan derivarse de la no ejecución o
                            ejecución defectuosa del contrato para evitar que se agrave. Los daños que deriven de no haber
                            adoptado tales medidas serán responsabilidad del viajero.

                        <p><strong>Atención al Viajero: </strong>El viajero puede ponerse en contacto con el organizador
                            y/o la agencia
                            vendedora de forma rápida y eficaz, interponer quejas y reclamaciones y/o solicitar
                            información sobre el viaje combinado: Teléfono: 950 627 019, Correo electrónico:
                            info@edadeoro.es y dirección Avda. de las Gaviotas, 12-14 – 04740 Roquetas de Mar (Almería)
                            Los datos de contacto del organizador serán los que figuren en la documentación final del viaje.</p>

                        <p><strong>Cancelación: </strong> El viajero podrá desistir del viaje en cualquier momento si lo
                            comunica antes del inicio del viaje. En tal caso, deberá abonar las siguientes penalizaciones:</p>
                        <ul>
                            <li>
                                <p>
                                    Si el desistimiento se produce con más de 10 días de antelación al señalado para el
                                    comienzo del viaje y menos de 15 días, el 5% del importe global, de 10 a 3 días, el 15%, 
                                    en las 48 horas anteriores a la salida, el 25%.
                                </p>
                            </li>
                            <li>
                                <p>De no presentarse a la hora prevista para la salida del bús si lo hubiera, o entrada
                                    en el hotel no tendrá derecho a devolución alguna. La penalización pactada no será
                                    aplicable cuando concurran circunstancias inevitables y extraordinarias en el lugar de destino
                                    o en las inmediaciones que afecten de forma significativa a la ejecución del viaje combinado
                                    o al transporte de pasajeros al lugar de destino. En este caso, el viajero tendrá derecho
                                    al reembolso completo de cualquier pago realizado, pero no a una compensación adicional.</p>
                            </li>
                        </ul>

                        <p>
                            <strong>Modificaciones del viaje: </strong> El viaje combinado se prestará conforme a la
                            información precontractual facilitada salvo en caso de que el cambio sea insignificante.
                        </p>

                        <p>
                            <strong>Seguro Incluido:</strong> Esta programación incluye un seguro que cubre gastos de
                            asistencia en viaje, incluidos los de repatriación en caso de accidente, enfermedad o
                            fallecimiento según los
                            límites y condiciones recogidas en el mismo y que son susceptibles de ampliación.
                        </p>

                        <p><strong>Documentación: </strong>El viajero reconoce que debe disponer de su documentación
                            personal y familiar perfectamente en regla, ya sea el pasaporte o el DNI.</p>

                        <p><strong>Equipajes: </strong>Se admitirá totalmente gratis el transporte de una maleta por
                            viajero, cuyo peso no exceda de 25 Kg. en viaje de autocar. En caso de pérdida o deterioro
                            del equipaje durante el
                            trayecto, la responsabilidad recae sobre la empresa transportista.</p>

                        <h4>Información básica sobre protección de datos: </h4>
                        <p><strong>Responsable del tratamiento:</strong> Viajes Cemo S.A. </p>
                        <p><strong>Finalidad principal: </strong>Gestión de la reserva del viaje contratado, así como su
                            seguimiento, documentación y facturación. Cumplimiento de
                            obligaciones legales, contables, tributarias y administrativas. </p>
                        <p><strong>Legitimación: </strong>Consentimiento del interesado, relación contractual, interés
                            legítimo y obligación legal.</p>
                        <p><strong>Destinatarios: </strong>No se cederán datos a terceros, salvo autorización expresa,
                            obligación legal o cuando sean necesarios para la prestación del servicio de viaje. </p>
                        <p><strong>Sus derechos: </strong>Acceder, rectificar y suprimir sus datos, así como a la
                            portabilidad de estos; a la limitación u oposición a su tratamiento, a recibir una
                            información leal y transparente, a revocar el
                            consentimiento dado, a la conservación de sus datos, a no ser objeto de decisiones
                            automatizadas
                            y a reclamar ante la AEPD. </p>
                        <p><strong>Procedencia: </strong>Datos proporcionados por el titular y/o obtenidos con su
                            autorización para la/s finalidad/es principal/es. </p>
                        <p><strong>Información adicional: </strong>
                            <a href="/politica">Edad de Oro - Política de privacidad</a>
                        </p>
                        <p><strong>Notificaciones: </strong>El viajero acepta que las comunicaciones referentes a
                            obligaciones legales, así como al desarrollo de la relación contractual le sean remitidas al
                            teléfono móvil indicado
                            al registrarse en nuestra web, por medio de SMS o tecnología similar.</p>
                        <p>El viajero reconoce haber sido informado de las presentes condiciones generales, siendo
                            aceptadas sin reservas.</p>
                        <!-- <p>Conforme y acepto</p>
                        <p>El/los viajero/s</p> -->
                    </div>
                </div>
            </div>
        
    </div>      
</template>

<script>

//import MenuOpcion from '@/components/MenuOpcion.vue'

export default {
    name: 'condiciones',
    components: {
        //MenuOpcion,
    },

    data() {
        return {
            titulo: "CONDICIONES GENERALES",
        }
    },
    
}
</script>